import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import autoBind from 'react-autobind';
import { renderInput } from 'src/components/misc/redux-form-helpers';
import { isBlank } from 'src/components/misc/validations';

class EmailToJourneyForm extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {};
    }

    render() {
        const { handleSubmit, t, offerUrl } = this.props;
        return (
            <form className="form-horizontal" onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-12">
                        <Field
                            name="emailInput"
                            placeholder="Email"
                            label={t('email_to_journey.form.email')}
                            t={t}
                            readOnly={offerUrl != null}
                            required
                            component={renderInput}
                            rows={3}
                            maxRows={5}
                            multiline
                        />
                    </div>
                    <div className="col-md-6">
                        <Field
                            name="internalReference"
                            placeholder="Interne Referenz"
                            label="Interne Referenz"
                            t={t}
                            component={renderInput}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

const validate = (values, props) => {
    const errors = {};
    const { t } = props;
    if (isBlank(values.emailInput)) errors.emailInput = t('email_to_journey.errors.no_content');
    if (values.emailInput && values.emailInput.length > 2500)
        errors.emailInput = t('email_to_journey.errors.character_limit_reached_email');
    if (values.internalReference && values.internalReference.length >= 10)
        errors.internalReference = t('email_to_journey.errors.character_limit_reached_reference');
    return errors;
};

export default reduxForm({
    form: 'EmailToJourneyForm',
    validate,
})(EmailToJourneyForm);
